var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack6Solid11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.13,11.78H10.4L9.72,10H6.57l-.65,1.79H4.23L7.3,3.91H9ZM9.21,8.67,8.12,5.75,7.06,8.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack6Solid11);
export default __webpack_public_path__ + "static/media/Symbolpack_6_solid_11.4f6fdded538faa6be28f34f3e086c9d9.svg";
export { ForwardRef as ReactComponent };